import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { Box, Tab, Tabs } from '@mui/material';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, Typography } from '@mui/material';

// project imports
import Profile from './Profile';
import MainCard from 'ui-component/cards/MainCard';
import useAuth from 'hooks/useAuth';
// import UserProfile from './UserProfile'
// import ChangePassword from './ChangePassword'
import Data from '../Profile2/Data';

// animation
const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

// tabs
function TabPanel({ children, value, index, ...other }) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

// ==============================|| PROFILE 3 ||============================== //

const Profile3 = () => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [open, setOpen] = React.useState(false);
    const { isProfile } = useAuth();
    const theme = useTheme();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (!isProfile) {
            setOpen(true);
        }
    }, []);

    return (
        <MainCard title="Cài đặt trợ lý">
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title1"
                aria-describedby="alert-dialog-slide-description1"
            >
                {open && (
                    <>
                        <DialogTitle id="alert-dialog-slide-title1">Cập nhật thông tin</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description1">
                                <Typography variant="body2" component="span">
                                    Vui lòng cập nhật thông tin
                                </Typography>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                variant="outlined"
                                size="small"
                                sx={{ color: theme.palette.error.dark, borderColor: theme.palette.error.dark }}
                                onClick={handleClose}
                                color="secondary"
                            >
                                Không
                            </Button>
                            <Button variant="outlined" size="small" onClick={handleClose}>
                                Đồng ý
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            <div>
                <Tabs
                    value={value}
                    indicatorColor="primary"
                    onChange={handleChange}
                    sx={{
                        mb: 3,
                        minHeight: 'auto',
                        '& button': {
                            minWidth: 100
                        },
                        '& a': {
                            minHeight: 'auto',
                            minWidth: 10,
                            py: 1.5,
                            px: 1,
                            mr: 2.25,
                            color: 'grey.600'
                        },
                        '& a.Mui-selected': {
                            color: 'primary.main'
                        }
                    }}
                    aria-label="simple tabs example"
                    variant="scrollable"
                >
                    <Tab component={Link} to="#" label="Thông tin chung" {...a11yProps(0)} />
                    {/* <Tab component={Link} to="#" label="Hóa đơn" {...a11yProps(1)} /> */}
                    {/* <Tab component={Link} to="#" label="Bảo mật" {...a11yProps(2)} />
                    <Tab component={Link} to="#" label="Thông báo" {...a11yProps(3)} /> */}
                    <Tab component={Link} to="#" label="Dữ liệu" {...a11yProps(1)} />
                </Tabs>
                <TabPanel value={value} index={0}>
                    <Profile />
                </TabPanel>
                {/* <TabPanel value={value} index={1}>
                    <Billing />
                </TabPanel> */}
                <TabPanel value={value} index={1}>
                    {/* <UserProfile />
                    <ChangePassword /> */}
                    <Data />
                </TabPanel>
                {/* <TabPanel value={value} index={3}>
                    <Notifications />
                </TabPanel> */}
            </div>
        </MainCard>
    );
};

export default Profile3;
